import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busbookingformarriage() {


const cardData = {
keyword: "Bus Booking for Marriage",
headingDescription: "Ruturaj Enterprises provides Bus Booking for Marriage in Pune for families who need organized transportation for guests, relatives, friends, and groups attending marriage ceremonies and related functions. From AC and luxury buses to suitable options for marriage processions, guest pickups, venue transfers, and longer journeys, transportation can be planned around the number of passengers, pickup points, ceremony timings, destination, and overall marriage itinerary.",
topPlaces: [
{
title: "Wakad",
description: "Wakad has numerous hotels, banquet facilities, restaurants, and event spaces that can be part of marriage celebrations in and around Pune. Dedicated marriage bus transportation helps families move guests between residences, accommodation, ceremony venues, and reception locations according to the planned schedule."
},
{
title: "Viman Nagar",
description: "Viman Nagar is a convenient area for wedding guests due to its hotels, restaurants, event facilities, and connectivity with other parts of Pune. A dedicated bus can be arranged for guest pickup, venue transfers, and return transportation during marriage functions."
},
{
title: "Hadapsar",
description: "Hadapsar offers a mix of hotels, residential areas, banquet venues, and event spaces that may be included in marriage itineraries. Group transportation allows relatives and guests to travel together between selected pickup points and marriage venues without relying on multiple private vehicles."
},
{
title: "Pashan",
description: "Pashan and its surrounding areas provide access to residential communities, hotels, and event facilities suitable for family functions and marriage celebrations. A marriage bus can support planned guest transportation between homes, accommodation locations, and ceremony venues."
},
{
title: "Lonavala",
description: "Lonavala is frequently considered for destination-style marriage celebrations because of its resorts, scenic surroundings, and event properties. Families can arrange dedicated bus transportation from Pune to move relatives and invited guests together for ceremonies, receptions, and related functions."
},
{
title: "Alibaug",
description: "Alibaug offers resorts and private event properties that can be suitable for destination marriage functions and family celebrations. A dedicated bus provides a practical way to coordinate guest travel from Pune while keeping relatives together during the journey."
},
{
title: "Satara",
description: "Satara and its surrounding region can be included in marriage itineraries involving family functions and gatherings outside Pune. Group bus transportation helps families organize travel for relatives and guests while accommodating planned pickup points, luggage, and event schedules."
},
{
title: "Kolhapur",
description: "Kolhapur is an important city for family gatherings, traditional celebrations, and marriage functions in Maharashtra. A suitable-capacity bus can transport relatives and guests from Pune for longer marriage journeys while providing a common travel arrangement."
},
{
title: "Nashik",
description: "Nashik has hotels, resorts, banquet facilities, and event venues that can host marriage ceremonies and receptions. Dedicated marriage transportation from Pune can help families coordinate guest travel for ceremonies, accommodation transfers, and return journeys."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar provides a scenic setting for family celebrations, destination marriages, and private functions at hotels and resorts. A dedicated bus can help transport wedding parties and relatives from Pune while maintaining a coordinated schedule for the event."
}
],
services: [
{
name: "Marriage Bus Rental Pune",
description: "Marriage Bus Rental Pune provides dedicated transportation for relatives, friends, family members, and invited guests attending marriage ceremonies and celebrations. Ruturaj Enterprises can arrange suitable buses according to passenger count, route, pickup locations, venue distance, function timings, and required travel duration."
},
{
name: "Marriage Bus Hire Pune",
description: "Marriage Bus Hire Pune is useful for families who need organized group transportation between homes, hotels, banquet halls, and marriage venues. A dedicated bus can reduce the need for multiple private vehicles and make it easier to coordinate guest movement during important functions."
},
{
name: "Marriage Bus Booking Pune",
description: "Marriage Bus Booking Pune can be planned for marriage ceremonies, receptions, engagement functions, family gatherings, and other related events. Advance transportation planning helps coordinate passenger numbers, pickup points, venue locations, ceremony schedules, waiting requirements, and return travel."
},
{
name: "AC Bus for Marriage Pune",
description: "AC Bus for Marriage Pune offers a comfortable travel option for guests attending marriage functions, particularly during warm weather or when longer journeys are involved. It can be used for local venue transfers, hotel pickups, destination celebrations, ceremony transportation, and reception travel."
},
{
name: "Luxury Bus for Marriage Function Pune",
description: "Luxury Bus for Marriage Function Pune is suitable for families looking for a more premium group transportation experience during important celebrations. Luxury buses can be considered for special guests, destination marriages, VIP transfers, receptions, and longer journeys where enhanced comfort is preferred."
},
{
name: "Bus for Marriage Guests Pune",
description: "Bus for Marriage Guests Pune provides organized transportation for relatives, friends, family members, and invited attendees. Guest travel can be coordinated from selected pickup points to the marriage venue, reception hall, accommodation, or other locations included in the event itinerary."
},
{
name: "Marriage Guest Transportation Pune",
description: "Marriage Guest Transportation Pune helps families manage transportation for guests arriving from different residential areas, hotels, railway stations, and meeting points. Dedicated group travel can simplify movement to and from marriage venues while keeping the guest schedule coordinated."
},
{
name: "Wedding and Marriage Bus Rental Pune",
description: "Wedding and Marriage Bus Rental Pune supports transportation requirements for complete wedding and marriage celebrations, including engagement, haldi, mehendi, sangeet, ceremony, reception, and family functions. Bus arrangements can be planned around the different venues and timings involved in the celebration."
},
{
name: "Marriage Function Bus Hire Pune",
description: "Marriage Function Bus Hire Pune is suitable for transporting guests to ceremonies, receptions, family gatherings, religious functions, and other marriage-related events. Vehicle selection can be based on group size, journey distance, pickup requirements, and the schedule of each function."
},
{
name: "Marriage Ceremony Bus Rental Pune",
description: "Marriage Ceremony Bus Rental Pune provides shared transportation for relatives and guests attending traditional marriage ceremonies and associated functions. A dedicated bus helps families organize group movement between residences, hotels, ceremony venues, and reception locations."
},
{
name: "Bus for Marriage Procession Pune",
description: "Bus for Marriage Procession Pune can be arranged for family members and guests participating in planned marriage processions and group arrivals. Transportation can be coordinated according to the procession route, number of passengers, starting point, timing, and final marriage venue."
},
{
name: "Marriage Group Transportation Pune",
description: "Marriage Group Transportation Pune allows larger groups of relatives and guests to travel together instead of depending on several individual vehicles. It is useful for marriage ceremonies, receptions, destination functions, family gatherings, and coordinated transfers between multiple venues."
},
{
name: "Affordable Marriage Bus Rental Pune",
description: "Affordable Marriage Bus Rental Pune provides a practical option for families managing transportation for a large number of marriage guests. Selecting an appropriately sized bus can simplify group travel and reduce the coordination involved in arranging numerous separate cars for the celebration."
},
{
name: "Marriage Event Bus Booking Pune",
description: "Marriage Event Bus Booking Pune can support transportation for ceremonies, receptions, engagement functions, family events, and other celebrations connected with the marriage. Bus schedules can be planned around event start times, venue locations, guest pickups, and post-function drop arrangements."
},
{
name: "Marriage Guest Pickup Bus Pune",
description: "Marriage Guest Pickup Bus Pune helps families collect relatives and invited guests from selected homes, hotels, railway stations, or designated meeting points. Pickup routes can be organized according to guest locations and the time they need to arrive at the marriage venue."
},
{
name: "Marriage Guest Drop Bus Pune",
description: "Marriage Guest Drop Bus Pune provides organized transportation after marriage ceremonies and receptions when guests need to return to hotels, homes, or designated drop locations. A dedicated bus can make the end-of-event travel process more convenient for larger guest groups."
},
{
name: "Marriage Venue Transportation Pune",
description: "Marriage Venue Transportation Pune supports movement between accommodation facilities, marriage halls, ceremony locations, reception venues, dining areas, and other event destinations. Dedicated buses can follow a planned itinerary so guests can move between functions without arranging separate transportation each time."
},
{
name: "Marriage Party Bus Rental Pune",
description: "Marriage Party Bus Rental Pune is suitable for group celebrations, family gatherings, pre-marriage events, and marriage-related parties where guests prefer shared transportation. Arrangements can be tailored around passenger numbers, travel route, celebration venue, and duration of the event."
},
{
name: "Marriage Outstation Bus Rental Pune",
description: "Marriage Outstation Bus Rental Pune provides group transportation for families and guests traveling from Pune to marriage destinations outside the city. It can be arranged for destination ceremonies, resort functions, receptions, and longer family journeys requiring coordinated shared travel."
},
{
name: "AC Marriage Guest Bus Pune",
description: "AC Marriage Guest Bus Pune provides an air-conditioned group travel option for relatives and invited guests attending marriage celebrations. It is useful for local venue transfers as well as longer journeys where guests require a comfortable shared transportation arrangement."
},
{
name: "Luxury Marriage Bus Hire Pune",
description: "Luxury Marriage Bus Hire Pune is designed for families seeking premium group transportation for relatives, special guests, and important attendees. It can be considered for destination marriage functions, VIP transfers, receptions, family movements, and longer journeys where additional comfort is preferred."
},
{
name: "Marriage Function Transportation Pune",
description: "Marriage Function Transportation Pune helps coordinate guest travel across different functions and venues during a marriage celebration. Ruturaj Enterprises can support transportation planning based on passenger strength, pickup points, ceremony timings, route requirements, venue locations, and the duration of the overall event."
}
],
tableData: [
["Marriage Bus Rental Pune", "Marriage Bus Hire Pune"],
["Marriage Bus Booking Pune", "AC Bus for Marriage Pune"],
["Luxury Bus for Marriage Function Pune", "Bus for Marriage Guests Pune"],
["Marriage Guest Transportation Pune", "Wedding and Marriage Bus Rental Pune"],
["Marriage Function Bus Hire Pune", "Marriage Ceremony Bus Rental Pune"],
["Bus for Marriage Procession Pune", "Marriage Group Transportation Pune"],
["Affordable Marriage Bus Rental Pune", "Marriage Event Bus Booking Pune"],
["Marriage Guest Pickup Bus Pune", "Marriage Guest Drop Bus Pune"],
["Marriage Venue Transportation Pune", "Marriage Party Bus Rental Pune"],
["Marriage Outstation Bus Rental Pune", "AC Marriage Guest Bus Pune"],
["Luxury Marriage Bus Hire Pune", "Marriage Function Transportation Pune"]
],
whychoose: [
{
WhyChooseheading: "Dedicated Guest Travel",
WhyChoosedescription: "Marriage celebrations often bring together relatives and friends from different locations, making transportation an important part of event planning. A dedicated bus provides a centralized travel arrangement for moving guests between residences, hotels, ceremony venues, and reception locations."
},
{
WhyChooseheading: "Suitable for Different Group Sizes",
WhyChoosedescription: "The number of marriage guests can vary significantly from one function to another. Ruturaj Enterprises supports group transportation requirements with suitable vehicle capacities, helping families select an option according to their expected number of passengers."
},
{
WhyChooseheading: "Convenient Pickup Arrangements",
WhyChoosedescription: "Guest pickup can become challenging when relatives are staying at different locations across Pune. Planned bus transportation can cover selected pickup points and bring guests together at the marriage venue according to the required arrival schedule."
},
{
WhyChooseheading: "Comfortable AC Travel",
WhyChoosedescription: "AC buses can provide a more comfortable environment for guests traveling to marriage functions, especially during warmer periods or on longer routes. They can be useful for hotel transfers, local venue transportation, destination marriages, and extended family journeys."
},
{
WhyChooseheading: "Premium Options for Special Guests",
WhyChoosedescription: "Families may want a more refined transportation experience for senior relatives, VIP attendees, or important wedding guests. Luxury marriage bus options can support premium group travel for ceremonies, receptions, destination functions, and longer journeys."
},
{
WhyChooseheading: "Useful for Destination Functions",
WhyChoosedescription: "Marriage celebrations outside Pune require transportation planning for guests traveling between cities, hotels, resorts, and event venues. A dedicated bus helps maintain group coordination during longer journeys and makes destination marriage logistics easier to organize."
},
{
WhyChooseheading: "Support Across Multiple Functions",
WhyChoosedescription: "A marriage itinerary may include engagement, haldi, mehendi, sangeet, ceremony, reception, and other family events at different locations. Transportation can be arranged according to the timing and location of each function so guests have a coordinated travel option throughout the celebration."
},
{
WhyChooseheading: "Flexible Event Transportation",
WhyChoosedescription: "Ruturaj Enterprises supports marriage transportation requirements based on guest count, route, venue, pickup locations, travel duration, and preferred bus type. This makes it possible to plan transportation for intimate family functions as well as larger marriage celebrations involving guests from multiple locations."
}
]
};











const faqData = [
{
question: "Why choose Ruturaj Enterprises for bus booking for marriage functions?",
answer: "Ruturaj Enterprises provides practical group transportation arrangements for marriage ceremonies and related events. A dedicated bus can help families transport relatives and guests between homes, hotels, marriage halls, banquet venues, railway stations, airports, and reception locations according to the function schedule."
},
{
question: "Can I book a bus for marriage guests?",
answer: "Marriage organizers and families can book a suitable bus when several guests need to travel together. Selecting the vehicle according to the guest count can reduce the need for multiple cars and make transportation between different marriage venues easier to coordinate."
},
{
question: "What marriage functions can be covered through bus booking?",
answer: "Bus transportation can be arranged for engagement ceremonies, haldi, mehendi, sangeet, wedding ceremonies, receptions, family gatherings, and other marriage-related programs. The travel plan can be structured around the timing and locations of each function."
},
{
question: "What seating capacity is available for marriage group transportation?",
answer: "The required bus capacity depends on the number of relatives and guests traveling together. Ruturaj Enterprises can arrange different group transportation options, including 20, 26, 32, 35, 45, and 50 Seater Buses based on the expected passenger count and itinerary."
},
{
question: "Can I book a bus for marriage guests arriving at Pune Airport?",
answer: "Guests arriving through Pune Airport can be transported to hotels, homes, marriage halls, or other venues through a dedicated bus arrangement. This can be particularly helpful when several relatives arrive around the same time and need coordinated transportation."
},
{
question: "Can a rental bus transport guests between the hotel and marriage venue?",
answer: "A rental bus can be scheduled to move guests between hotels, guest houses, residences, marriage halls, banquet venues, and reception locations. Sharing the venue timings in advance can help organize guest pickups and drops around the marriage program."
},
{
question: "Can I arrange bus transportation for relatives coming from another city?",
answer: "Families can organize bus transportation for groups arriving from other cities and plan their onward movement for the marriage functions. Pickup and drop arrangements can be coordinated according to the group's arrival details, accommodation, venue locations, and ceremony timings."
},
{
question: "Is a bus suitable for a large family marriage ceremony?",
answer: "Large family marriages often involve transportation between several locations, making a dedicated bus a convenient option for group movement. Relatives can travel together for ceremonies, meals, receptions, and other scheduled activities without depending on several separate vehicles."
},
{
question: "Can I book a bus for multiple marriage events?",
answer: "Transportation can be planned for multiple marriage events when the complete itinerary is shared beforehand. Details such as pickup points, venues, function timings, passenger count, and expected travel duration help create a coordinated bus schedule for the celebrations."
},
{
question: "How can I book a bus for marriage with Ruturaj Enterprises?",
answer: "To arrange marriage transportation with Ruturaj Enterprises, provide the wedding or marriage dates, pickup locations, venue addresses, number of guests, required bus capacity, and travel timings. The rental plan can then be organized around the family's complete marriage itinerary."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Akash Pawar",
feedback:
"We arranged a bus from Ruturaj Enterprises for our brother's marriage and used it to transport relatives between the hotel and different function venues. Having everyone travel together made the guest movement much easier to manage, especially during the busy marriage schedule.",
rating: 5
},
{
id: 2,
name: "Miss. Manisha Patil",
feedback:
"Our family booked a bus through Ruturaj Enterprises for a marriage function with guests coming from different places. The dedicated group transportation helped us coordinate everyone for the ceremonies and reception without depending on several separate cars. It was a convenient arrangement for our family.",
rating: 5
}
];





















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Booking for Marriage",
  "image": "https://ruturajenterprises.com/assets/images/bus-booking-for-marriage.webp",
  "description":
    "Bus Booking for Marriage from Ruturaj Enterprises provides organized transportation for marriage guests, relatives, family members, friends and large groups attending wedding functions in Pune and nearby destinations. Marriage Bus Rental Pune is suitable for transporting guests between homes, hotels, marriage halls, banquet venues, resorts, reception locations, railway stations and airports. Marriage Bus Hire Pune can be arranged according to the number of passengers, pickup locations, wedding venue, travel schedule and duration of the function. Marriage Bus Booking Pune helps families coordinate guest transportation for engagement ceremonies, haldi, mehendi, sangeet, marriage ceremonies, receptions and destination weddings. AC Bus for Marriage Pune offers a comfortable travel option for guests during warm weather and longer journeys, while Luxury Bus for Marriage Function Pune is suitable for premium transportation requirements during important family occasions. Bus for Marriage Guests Pune can accommodate groups travelling together between hotels and ceremony venues, reducing the need to arrange multiple smaller vehicles. Bus for Marriage Function Pune is useful for transporting relatives and invitees to banquet halls, marriage gardens, resorts and other event locations. Marriage Shuttle Bus Pune can be arranged for repeated transfers between hotels, parking areas, accommodation facilities and wedding venues throughout the event schedule. Different seating capacities can be selected according to the guest count, including 32 Seater, 35 Seater, 45 Seater and 50 Seater buses, subject to availability and trip requirements. Marriage Guest Transportation Pune can also be customized for guests travelling from Mumbai, Nashik, Kolhapur, Satara, Sangli, Solapur, Ahmednagar, Goa, Konkan and other Maharashtra locations to Pune. Airport pickup and railway station transfers can be coordinated for outstation guests arriving for the marriage ceremony. Local pickup and drop arrangements can cover Kothrud, Baner, Aundh, Wakad, Hinjewadi, Viman Nagar, Kharadi, Hadapsar, Kondhwa, Katraj, Shivajinagar, Swargate, Pimpri, Chinchwad, Talegaon, Moshi, Bhosari and surrounding Pune areas. Ruturaj Enterprises supports full-day, multi-day, local and outstation marriage transportation requirements with customized routes, scheduled guest transfers and dedicated driver support.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/bus-booking-for-marriage"
  }
};








    return (
        <div>

<Helmet>
  <title>Bus Booking for Marriage | Marriage Bus Rental Pune | +91 9763381382</title>

  <meta
    name="description"
    content="Bus Booking for Marriage for guests, relatives and family groups with AC, luxury and large-capacity buses for marriage functions, ceremonies, receptions and venue transfers."
  />

  <meta
    name="keywords"
    content="Marriage Bus Rental Pune, Marriage Bus Hire Pune, Marriage Bus Booking Pune, AC Bus for Marriage Pune, Luxury Bus for Marriage Function Pune, Bus for Marriage Guests Pune, Bus for Marriage Function Pune, Marriage Guest Transportation Pune, Marriage Guest Bus Hire Pune, Marriage Guest Bus Booking Pune, Marriage Shuttle Bus Pune, Marriage Group Transportation Pune, Marriage Bus on Rent Pune, Marriage Bus Rental in Pune, Marriage Bus Hire in Pune, Marriage Bus Booking in Pune, Bus Rental for Marriage Ceremony Pune, Bus Hire for Marriage Ceremony Pune, Bus Booking for Marriage Ceremony Pune, Marriage Function Bus Rental Pune, Marriage Function Bus Hire Pune, Marriage Function Bus Booking Pune, Marriage Ceremony Bus Rental Pune, Marriage Ceremony Bus Hire Pune, Marriage Ceremony Bus Booking Pune, Wedding Marriage Bus Rental Pune, Marriage Reception Bus Rental Pune, Marriage Reception Bus Hire Pune, Marriage Reception Transportation Pune, Marriage Event Bus Rental Pune, Marriage Event Transportation Pune, Marriage Guest Transportation Bus Pune, Marriage Guest Transfer Pune, Marriage Guest Pickup Pune, Marriage Guest Drop Pune, Marriage Family Transportation Pune, Marriage Relatives Transportation Pune, Marriage Party Bus Rental Pune, Marriage Group Bus Hire Pune, Marriage Group Bus Booking Pune, Marriage Bus with Driver Pune, Private Marriage Bus Pune, AC Marriage Bus Rental Pune, AC Marriage Bus Hire Pune, Luxury Marriage Bus Rental Pune, Luxury Marriage Bus Hire Pune, Premium Marriage Bus Pune, Comfortable Marriage Bus Pune, Reliable Marriage Bus Rental Pune, Affordable Marriage Bus Rental Pune, Large Group Marriage Bus Pune, 32 Seater Bus for Marriage Pune, 35 Seater Bus for Marriage Pune, 45 Seater Bus for Marriage Pune, 50 Seater Bus for Marriage Pune, 32 Seater Marriage Bus Rental Pune, 35 Seater Marriage Bus Rental Pune, 45 Seater Marriage Bus Rental Pune, 50 Seater Marriage Bus Rental Pune, Marriage Bus for Large Group Pune, Marriage Bus for Family Pune, Marriage Bus for Relatives Pune, Marriage Bus for Friends Pune, Marriage Bus for Baraat Pune, Baraat Bus Rental Pune, Baraat Transportation Bus Pune, Marriage Airport Transfer Pune, Marriage Airport Pickup Pune, Marriage Airport Drop Pune, Marriage Railway Station Transfer Pune, Marriage Hotel Transfer Pune, Marriage Resort Transfer Pune, Marriage Hotel to Venue Bus Pune, Marriage Venue Transportation Pune, Marriage Hall Bus Rental Pune, Banquet Hall Marriage Bus Pune, Resort Marriage Bus Rental Pune, Destination Marriage Bus Pune, Marriage Shuttle Service Pune, Marriage Hotel Shuttle Bus Pune, Marriage Venue Shuttle Pune, Marriage Parking Shuttle Bus Pune, Marriage Ceremony Shuttle Pune, Haldi Function Bus Rental Pune, Mehendi Function Bus Rental Pune, Sangeet Function Bus Rental Pune, Engagement Function Bus Rental Pune, Marriage Reception Shuttle Pune, Marriage Day Bus Rental Pune, Marriage Full Day Bus Rental Pune, Marriage Multi Day Bus Rental Pune, Marriage Outstation Bus Rental Pune, Marriage Bus for Outstation Pune, Marriage Bus for Maharashtra Pune, Marriage Bus from Mumbai to Pune, Marriage Bus from Nashik to Pune, Marriage Bus from Kolhapur to Pune, Marriage Bus from Satara to Pune, Marriage Bus from Sangli to Pune, Marriage Bus from Solapur to Pune, Marriage Bus from Ahmednagar to Pune, Marriage Bus from Goa to Pune, Marriage Bus from Konkan to Pune, Marriage Bus Rental Near Pune, Marriage Bus Hire Near Pune, Marriage Bus Booking Near Pune, Marriage Bus Rental Pimpri Chinchwad, Marriage Bus Rental Wakad, Marriage Bus Rental Hinjewadi, Marriage Bus Rental Kothrud, Marriage Bus Rental Baner, Marriage Bus Rental Aundh, Marriage Bus Rental Viman Nagar, Marriage Bus Rental Kharadi, Marriage Bus Rental Hadapsar, Marriage Bus Rental Kondhwa, Marriage Bus Rental Katraj, Marriage Bus Rental Shivajinagar, Marriage Bus Rental Swargate, Marriage Bus Rental Pimpri, Marriage Bus Rental Chinchwad, Marriage Bus Rental Talegaon, Marriage Bus Rental Moshi, Marriage Bus Rental Bhosari"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Busbookingformarriage;